//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import {
  selectFileManagerIsLoading,
  selectFolderIsLoading,
  selectLocationPointer,
  selectLocationsLength
} from '@/redux/selectors/fileManagerSelectors';
import { goBackPath, goForwardPath, refreshFiles } from '@/redux/slices/fileManagerSlice';
import { IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const BackForwardNav = () => {
  const dispatch = useAppDispatch();
  const fileManagerLoading = useAppSelector(selectFileManagerIsLoading);
  const folderLoading = useAppSelector(selectFolderIsLoading);
  const locationPointer = useAppSelector(selectLocationPointer);
  const locationsLength = useAppSelector(selectLocationsLength);
  const canGoBack = locationsLength + locationPointer > 1;
  const loading = fileManagerLoading || folderLoading;

  const handleGoBack = () => {
    dispatch(goBackPath());
    dispatch(refreshFiles());
  };

  const handleGoForward = () => {
    dispatch(goForwardPath());
    dispatch(refreshFiles());
  };

  return (
    <>
      <IconButton aria-label="go back" onClick={handleGoBack} disabled={!canGoBack || loading} style={{ marginLeft: -20 }}>
        <PolarisIcon icon="left" height={20} />
      </IconButton>
      <IconButton aria-label="go forward" onClick={handleGoForward} disabled={locationPointer === 0 || loading} style={{ marginRight: 10 }}>
        <PolarisIcon icon="right" height={20} />
      </IconButton>
    </>
  );
};

export default BackForwardNav;
